import { segmentTrackCustom } from './track'
import {
  convertProductArrayToSegmentProducts,
  convertProductFilterToSegment,
  convertProductToSegmentProduct,
  convertProductToGA4Payload,
  convertCheckoutToGA4Payload,
} from './utils'
import { combineCartBackOrderData } from '../../selectors/cartSelectors'

export const DEFAULT_AFFILIATION = 'ParamountLiquor Web'

/**
 *  Browsing
 */
export const segmentTrackSearchProduct = (searchResult) => {
  segmentTrackCustom('Products Searched', {
    query: searchResult,
  })
}

export const segmentTrackProductListView = (URLSegment, productItems) => {
  const segmentProducts = convertProductArrayToSegmentProducts(productItems)

  segmentTrackCustom('Product List Viewed', {
    //list_id: 'main_list',
    category: URLSegment,
    email: window.subSupplierParentEmail,
    products: segmentProducts.slice(0, 30),
  })
}

export const segmentTrackProductListFilter = (filterOptions, productItems) => {
  const { CategoryURL: category } = filterOptions

  const segmentProducts = convertProductArrayToSegmentProducts(productItems)

  segmentTrackCustom('Product List Filtered', {
    //list_id: 'main_list',
    category,
    email: window.subSupplierParentEmail,
    ...convertProductFilterToSegment(filterOptions),
    products: segmentProducts.slice(0, 30),
  })
}

export const segmentTrackProductClicked = (product, config = {}) => {
  const { position } = config

  if (product?.sell_by_case) {
    segmentTrackCustom(
      'Product Clicked',
      convertProductToSegmentProduct(product, {
        position,
        price: product?.case_price,
        variant: 'case',
        quantity: product?.caseTotal,
      })
    )
  } else {
    segmentTrackCustom(
      'Product Clicked',
      convertProductToSegmentProduct(product, {
        position,
        price: product?.case_price,
        variant: 'case',
        quantity: product?.caseTotal,
      })
    )

    if (product?.unit_price) {
      segmentTrackCustom(
        'Product Clicked',
        convertProductToSegmentProduct(product, {
          position,
          price: product?.unit_price,
          variant: 'unit',
          quantity: product?.unitTotal,
        })
      )
    }
  }
}

export const segmentTrackProductViewed = (product, config = {}) => {
  const { position } = config

  if (product?.sell_by_case) {
    segmentTrackCustom(
      'view_item',
      convertProductToGA4Payload(product, {
        position,
        price: product?.case_price,
        variant: 'case',
        quantity: product?.caseTotal,
      })
    )
  } else {
    segmentTrackCustom(
      'view_item',
      convertProductToGA4Payload(product, {
        position,
        price: product?.case_price,
        variant: 'case',
        quantity: product?.caseTotal,
      })
    )

    if (product?.unit_price) {
      segmentTrackCustom(
        'view_item',
        convertProductToGA4Payload(product, {
          position,
          price: product?.unit_price,
          variant: 'unit',
          quantity: product?.unitTotal,
        })
      )
    }
  }
}

export const segmentTrackCartViewed = (products, cart, cartId) => {
  return (dispatch, getState) => {
    const store = getState()

    const cartList = combineCartBackOrderData(products, cart, [], store)

    if (cartList) {
      let sortedArrayOfCart = null

      sortedArrayOfCart = Object.values(cartList).sort((a, b) => (a.title > b.title ? 1 : -1))

      // const segmentProducts = convertProductArrayToSegmentProducts(sortedArrayOfCart)
      if (sortedArrayOfCart.length > 0 && cartId !== '') {
        segmentTrackCustom('view_cart', convertProductToGA4Payload(sortedArrayOfCart))
      }
      // if (segmentProducts.length > 0 && cartId !== '') {

      //   segmentTrackCustom('Cart Viewed', {
      //     cart_id: cartId,
      //     products: segmentProducts,
      //   })
      // }
    }
  }
}

export const segmentTrackCheckoutStarted = (cart, cartId, checkoutDetails) => {
  // const { total: value, subtotal: revenue, tax } = checkoutDetails
  const { total: value, subtotal: revenue, tax, appliedDiscountCoupons } = checkoutDetails
  if (cart) {
    let sortedArrayOfCart = null
    let couponName = appliedDiscountCoupons?.[0]?.InternalItemID || ''

    sortedArrayOfCart = cart.sort((a, b) => (a.title > b.title ? 1 : -1))

    const segmentProducts = convertProductArrayToSegmentProducts(sortedArrayOfCart)
    segmentTrackCustom('begin_checkout', convertCheckoutToGA4Payload(sortedArrayOfCart, { coupon: couponName, value }))

    // segmentTrackCustom('Checkout Started', {
    //   affiliation: DEFAULT_AFFILIATION,
    //   order_id: cartId,
    //   value,
    //   revenue,
    //   tax,
    //   currency: 'AUD',
    //   products: segmentProducts,
    // })
  }
}

const paymentMethodParser = (paymentMethod) => {
  if (paymentMethod === 'order-account') return 'Account'

  if (paymentMethod === 'order-airwallex-card') return 'Credit Card'

  if (paymentMethod === 'order-tillpayments-zippay') return 'Zip Pay'

  return 'None'
}

export const segmentTrackCheckoutStepViewed = (cart, cartId, paymentMethod, shippingMethod) => {
  const { list, total: value, appliedDiscountCoupons, tax } = cart

  segmentTrackCustom('Checkout Step Viewed', {
    checkout_id: cartId,
    step: 1,
    shipping_method: shippingMethod,
    payment_method: paymentMethodParser(paymentMethod),
  })
  // if (list) {
  //   let sortedArrayOfCart = null
  //   let couponName = appliedDiscountCoupons?.[0]?.InternalItemID || ''
  //   sortedArrayOfCart = list.sort((a, b) => (a.title > b.title ? 1 : -1))
  //   segmentTrackCustom(
  //     'purchase',
  //     convertCheckoutToGA4Payload(sortedArrayOfCart, {
  //       value,
  //       transaction_id: cartId,
  //       coupon: couponName,
  //       tax: tax,
  //       Shipping: shippingMethod,
  //       Payment_type: paymentMethodParser(paymentMethod),
  //     })
  //   )
  // }
}
export const segmentTrackPaymentInfoEntered = (cart, cartId, paymentMethod, shippingMethod) => {
  const { list, total: value, appliedDiscountCoupons } = cart

  if (list) {
    let sortedArrayOfCart = null
    let couponName = appliedDiscountCoupons?.[0]?.InternalItemID || ''
    sortedArrayOfCart = list.sort((a, b) => (a.title > b.title ? 1 : -1))

    segmentTrackCustom(
      'add_payment_info',
      convertCheckoutToGA4Payload(sortedArrayOfCart, {
        value,
        transaction_id: cartId,
        coupon: couponName,
        Payment_type: paymentMethodParser(paymentMethod),
      })
    )
  }
}
// export const segmentTrackPaymentInfoEntered = (cartId, paymentMethod, shippingMethod) => {
//   segmentTrackCustom('Payment Info Entered', {
//     checkout_id: cartId,
//     step: 1,
//     shipping_method: shippingMethod,
//     payment_method: paymentMethodParser(paymentMethod),
//   })
// }

export const segmentTrackCheckoutStepCompleted = (cart, paymentMethod, shippingMethod) => {
  const { list, total: value, appliedDiscountCoupons, tax, id } = cart

  if (list) {
    let sortedArrayOfCart = null
    let couponName = appliedDiscountCoupons?.[0]?.InternalItemID || ''
    sortedArrayOfCart = list.sort((a, b) => (a.title > b.title ? 1 : -1))

    segmentTrackCustom(
      'purchase',
      convertCheckoutToGA4Payload(sortedArrayOfCart, {
        value,
        transaction_id: id,
        coupon: couponName,
        tax: tax,
        Shipping: shippingMethod,
        Payment_type: paymentMethodParser(paymentMethod),
      })
    )
  }
}

// export const segmentTrackCheckoutStepCompleted = (cartId, paymentMethod, shippingMethod) => {
//   segmentTrackCustom('Checkout Step Completed', {
//     checkout_id: cartId,
//     step: 1,
//     shipping_method: shippingMethod,
//     payment_method: paymentMethodParser(paymentMethod),
//   })
// }

export const segmentTrackProductAdded = (product, config, cartId = null) => {
  segmentTrackCustom('add_to_cart', convertProductToGA4Payload(product, config))

  // segmentTrackCustom('Product Added', {
  //   cart_id: cartId,
  //   ...convertProductToSegmentProduct(product, config),
  // })
}

export const segmentTrackProductRemoved = (product, config, cartId = null) => {
  segmentTrackCustom('remove_from_cart', convertProductToGA4Payload(product, config))

  // segmentTrackCustom('Product Removed', {
  //   cart_id: cartId,
  //   ...convertProductToSegmentProduct(product, config),
  // })
}

export const segmentTrackProductAddedToWishlist = (product, config, favoritesId = null) => {
  segmentTrackCustom('add_to_wishlist', convertProductToGA4Payload(product, config))

  // segmentTrackCustom('Product Added to Wishlist', {
  //   //wishlist_id: favoritesId,
  //   wishlist_name: 'Order Template',
  //   ...convertProductToSegmentProduct(product, config),
  // })
}

export const segmentTrackProductRemovedFromWishlist = (product, config, favoritesId = null) => {
  segmentTrackCustom('Product Removed from Wishlist', {
    //wishlist_id: favoritesId,
    wishlist_name: 'Order Template',
    ...convertProductToSegmentProduct(product, config),
  })
}

export const segmentTrackWishlistProductAddedToCart = (product, config, cartId, favoritesId = null) => {
  segmentTrackCustom('Wishlist Product Added to Cart', {
    //wishlist_id: favoritesId,
    wishlist_name: 'Order Template',
    cart_id: cartId,
    ...convertProductToSegmentProduct(product, config),
  })
}
